export const CATEGORY_SPLIT_CHAR = '|'
export const REVIEW = 'review'
export const SELECTION = 'selection'
